import React, { useState } from 'react';

import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  TextField,
  Typography,
} from '@material-ui/core';
import FormGroup from '@material-ui/core/FormGroup';

import FloatingButton from '../../../../components/FloatingButton';
import { useAuthDataContext } from '../../../../context/auth/auth.provider';
import { useSinisterDataContext } from '../../../../context/sinister/sinister.provider';
import { dataLayerPush } from '../../../../helpers/dataLayerPush';

const Fact = () => {
  const { nextStep, sinister_body, updateSinisterBody } =
    useSinisterDataContext();
  const { user } = useAuthDataContext();
  const [title] = useState('¿Cómo sucedió el hecho?');
  const [fact, setFact] = useState(sinister_body.fact);
  const [policeInvolved, setPoliceInvolved] = useState(false);
  const [ambulanceInvolved, setAmbulanceInvolved] = useState(false);

  const [specialChars, setSpecialChars] = useState(false);
  const [limitChars, setLimitChars] = useState(false);
  const [validationMessage, setValidationMessage] = useState('');

  const callNextStep = () => {
    dataLayerPush('siniestro_descripcion_continuar', user?.id);
    nextStep();
    updateSinisterBody({
      fact: fact,
      police_involved: policeInvolved,
      ambulance_involved: ambulanceInvolved,
    });
  };

  const handleFact = (event: any) => {
    setValidationMessage('');

    if (
      String(event.target.value)
        .toLowerCase()
        .match(/^[a-zA-Z0-9:. ,;¡!¿?]*$/)
    ) {
      setSpecialChars(false);
    } else {
      setSpecialChars(true);
      setValidationMessage(
        'El texto no puede contener símbolos, íconos o caracteres especiales.'
      );
    }

    if (event.target.value.length > 1333) {
      setLimitChars(true);
      setValidationMessage(
        'El relato del hecho no debería superar los 1333 caracteres.'
      );
    } else {
      setLimitChars(false);
    }

    setFact(event.target.value);
  };

  return (
    <Grid container>
      <Grid container item lg={12}>
        <Box my={3}>
          <Typography
            variant="h6"
            color="textPrimary"
            style={{ fontFamily: 'Inter' }}
          >
            {title}
          </Typography>
        </Box>
      </Grid>
      <Grid container>
        <Grid item xs={12}>
          <TextField
            defaultValue={sinister_body.fact}
            id="outlined-multiline-static"
            multiline
            fullWidth
            size="medium"
            rows={8}
            placeholder="Describe lo ocurrido de la forma más detallada posible"
            variant="outlined"
            value={fact}
            onChange={handleFact}
            // error={fact?.length > 1333}
            error={specialChars || limitChars}
            helperText={
              validationMessage
              // fact?.length > 1333 && 'El relato del hecho no debería superar los 1333 caracteres'
              // !String(fact).toLowerCase().match(/^[a-zA-Z0-9:. ,;]*$/) && 'Por favor, no ingrese caracteres especiales. Solo letras y números.'
            }
          />
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Box ml={4} my={2}>
          <FormControl component="fieldset">
            <FormGroup aria-label="position">
              {sinister_body.incident_type === 'fire' ||
              sinister_body.incident_type === 'robbery' ||
              sinister_body.incident_type === 'crash' ? (
                <Grid>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={policeInvolved}
                        color="primary"
                        onChange={(event) =>
                          setPoliceInvolved(event.target.checked)
                        }
                      />
                    }
                    label="Hubo intervención de Policía, Prefectura, Gendarmería u otro Organismo público."
                    name="policeInvolved"
                    id="policeInvolved"
                  />
                </Grid>
              ) : null}
              {sinister_body.incident_type === 'crash' ? (
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={ambulanceInvolved}
                      color="primary"
                      onChange={(event) =>
                        setAmbulanceInvolved(event.target.checked)
                      }
                    />
                  }
                  label="Paticipó una ambulancia"
                  name="ambulanceInvolved"
                  id="ambulanceInvolved"
                />
              ) : null}
            </FormGroup>
          </FormControl>
        </Box>
      </Grid>
      <Grid container justify="center">
        <Grid item xs={12} sm={6}>
          <Box my={4}>
            <FloatingButton
              onClick={callNextStep}
              disabled={!fact || validationMessage != ''}
            >
              Continuar
            </FloatingButton>
          </Box>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Fact;
